module.exports = __webpack_public_path__ + "assets/token-active.b339a5a9.svg";